import { render, staticRenderFns } from "./CloseEventInComponent.vue?vue&type=template&id=3ed42e9a"
import script from "./CloseEventInComponent.vue?vue&type=script&lang=js"
export * from "./CloseEventInComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports